package com.dotdrives.web.pages.donations

import react.FC
import react.Props
import react.dom.html.ReactHTML.style

private val donationsStyles = """
    .donations-view-tabs {display:flex;gap:6px;align-items:center;padding:4px;background:#E5EBEF;border-radius:12px;width:fit-content}
    .donations-view-tab {border:0;background:transparent;padding:10px 18px;border-radius:9px;font:inherit;font-size:13px;font-weight:800;color:#60717C;cursor:pointer}
    .donations-view-tab-active {background:white;color:#25343D;box-shadow:0 1px 4px #25343D12}
    .donations-view-tab:focus-visible {outline:2px solid #B84818;outline-offset:2px}
    .donations-page { min-height: calc(100vh - 118px); }
    .donations-header { display: flex; flex-direction: column; gap: 12px; margin-bottom: 16px; }
    .donations-header-row { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }
    .donations-title { font-family: 'Quicksand', sans-serif; font-size: 22px; font-weight: 700; }
    .donations-topbar-actions { margin-left: auto; display: flex; align-items: center; gap: 10px; }
    .donations-topbar-button { min-height: 38px; padding: 8px 16px; font-size: 13px; }
    .donations-attention-button {
      position: relative; min-height: 38px; padding: 8px 16px; border: 1.5px solid #E4E8EC; border-radius: 99px;
      color: #5A6870; background: white; cursor: pointer; font-size: 13px; font-weight: 800;
    }
    .donations-attention-button-active { border-color: #C22C25; color: #C22C25; background: #FDECEA; }
    .donations-attention-badge {
      display: inline-flex; align-items: center; justify-content: center; min-width: 18px; height: 18px;
      margin-left: 6px; padding: 0 5px; border-radius: 99px; color: #fff; background: #C22C25;
      font-family: 'IBM Plex Mono', monospace; font-size: 10.5px; font-weight: 800;
    }
    .donations-search-row { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
    .donations-search {
      width: 230px; min-height: 38px; padding: 8px 14px; border: 1px solid transparent;
      border-radius: 99px; outline: none; color: #222D32; background: white; font-size: 13px;
    }
    .donations-search:focus { border-color: #F26223; box-shadow: 0 0 0 2px #FDE5DA; }
    .donations-filter-select {
      min-height: 34px; padding: 6px 14px; border: 1.5px solid #D6DBE0; border-radius: 99px;
      color: #5A6870; background: white; font-size: 12px; font-weight: 800; cursor: pointer;
    }
    .donations-month-nav {
      width: 26px; height: 26px; border: 1.5px solid #D6DBE0; border-radius: 50%;
      color: #5A6870; background: white; cursor: pointer; font-size: 12px; font-weight: 800;
    }
    .donations-month-label { font-family: 'IBM Plex Mono', monospace; font-size: 12px; font-weight: 800; color: #222D32; }
    .donations-month-total {
      margin-left: auto; font-family: 'IBM Plex Mono', monospace; font-size: 12.5px; color: #5A6870;
    }
    .donations-month-total b { color: var(--dot-positive); font-size: 15px; font-weight: 500; }
    .donations-inline-banner { margin-bottom: 12px; }

    .donations-ledger { display: flex; flex-direction: column; gap: 8px; }
    .donations-ledger-head {
      display: grid; grid-template-columns: 1.7fr 1.2fr 1.2fr 1fr 0.9fr 1fr; padding: 0 16px 8px;
      font-family: 'IBM Plex Mono', monospace; font-size: 11px; color: var(--dot-muted); letter-spacing: .5px;
    }
    .donations-row {
      display: grid; grid-template-columns: 1.7fr 1.2fr 1.2fr 1fr 0.9fr 1fr; align-items: center;
      width: 100%; padding: 12px 16px; border: 1px solid #E4E8EC; border-radius: 12px;
      color: inherit; background: white; text-align: left; cursor: pointer;
      transition: border-color 140ms ease, box-shadow 140ms ease;
    }
    .donations-row:hover, .donations-row:focus-visible {
      border-color: #F26223; box-shadow: 0 4px 14px rgba(34,45,50,.08); outline: none;
    }
    .donations-row-error { border-color: #F5B5A5; }
    .donations-row-giver { display: flex; align-items: center; gap: 11px; min-width: 0; }
    .donations-row-avatar {
      width: 32px; height: 32px; flex: 0 0 auto; display: flex; align-items: center; justify-content: center;
      border-radius: 50%; color: white; font-size: 12px; font-weight: 800;
    }
    .donations-row-name { font-weight: 800; font-size: 13.5px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .donations-row-memo { font-size: 11px; color: var(--dot-muted); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .donations-row-target { font-size: 12.5px; font-weight: 700; color: #3D4A52; }
    .donations-row-date { font-family: 'IBM Plex Mono', monospace; font-size: 12px; color: var(--dot-muted); }
    .donations-row-amount { text-align: right; font-family: 'IBM Plex Mono', monospace; font-size: 14px; font-weight: 500; color: var(--dot-positive); }
    .donations-row-amount-negative { color: #C22C25; }
    .donations-skeleton-row { padding: 12px 16px; border: 1px solid #E4E8EC; border-radius: 12px; background: white; }

    .donations-detail-backdrop, .donations-dialog-backdrop {
      position: fixed; inset: 0; z-index: 40; display: flex; justify-content: flex-end;
      background: rgba(34,45,50,.32);
    }
    .donations-dialog-backdrop { align-items: center; justify-content: center; padding: 16px; z-index: 60; }
    .donations-quick-dialog, .donations-yearend-dialog { max-height: calc(100dvh - 32px); overflow-y: auto; overscroll-behavior: contain; }
    .donations-month-group { display: flex; align-items: center; gap: 10px; flex: 0 0 auto; }
    .donations-quick-more select, .donations-quick-more textarea { width: 100%; min-width: 0; min-height: 42px; padding: 9px 12px; border: 1px solid #CBD2D7; border-radius: 9px; font: inherit; color: #222D32; background: white; }
    .donations-quick-more textarea { min-height: 78px; resize: vertical; }
    .donations-detail-panel {
      width: min(100%, 440px); height: 100%; overflow: auto; background: white;
      box-shadow: -12px 0 40px rgba(34,45,50,.18); animation: donations-slide-in 220ms ease both;
    }
    @keyframes donations-slide-in { from { transform: translateX(24px); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
    .donations-detail-head { padding: 20px 24px; color: white; background: #222D32; }
    .donations-detail-head-row { display: flex; justify-content: space-between; align-items: flex-start; }
    .donations-detail-id { font-family: 'IBM Plex Mono', monospace; font-size: 10px; color: #8FA0AA; letter-spacing: 1px; margin-bottom: 4px; }
    .donations-detail-amount { font-family: 'Quicksand', sans-serif; font-size: 26px; font-weight: 700; color: #6DBC88; }
    .donations-detail-amount-negative { color: #F29B8F; }
    .donations-detail-sub { font-size: 12.5px; color: #C9D3D9; margin-top: 4px; }
    .donations-detail-close { color: #8FA0AA; background: transparent; cursor: pointer; font-size: 16px; }
    .donations-detail-body { padding: 18px 24px; }
    .donations-detail-rows { display: flex; flex-direction: column; gap: 9px; margin-bottom: 16px; }
    .donations-detail-row { display: flex; justify-content: space-between; font-size: 13px; border-bottom: 1px solid #F2F4F6; padding-bottom: 8px; }
    .donations-detail-row-key { color: var(--dot-muted); font-weight: 700; }
    .donations-detail-row-val { font-weight: 800; color: #222D32; }
    .donations-detail-loading { padding: 24px; display: flex; flex-direction: column; gap: 12px; }
    .donations-detail-refund {
      width: calc(100% - 48px); margin: 4px 24px 20px; padding: 10px; border: 1.5px solid #F5B5A5;
      border-radius: 99px; color: #C22C25; background: white; cursor: pointer; font-size: 12px; font-weight: 800;
    }
    .donations-detail-refund:disabled { opacity: .6; cursor: not-allowed; }

    .donations-attention-panel {
      width: min(100%, 460px); height: 100%; overflow: auto; background: white;
      box-shadow: -12px 0 40px rgba(34,45,50,.18); animation: donations-slide-in 220ms ease both;
    }
    .donations-attention-head { padding: 20px 26px; color: white; background: #222D32; display: flex; justify-content: space-between; align-items: center; }
    .donations-attention-title { font-family: 'Quicksand', sans-serif; font-size: 18px; font-weight: 700; }
    .donations-attention-subtitle { font-size: 12px; color: #8FA0AA; margin-top: 2px; }
    .donations-attention-body { padding: 20px 26px; display: flex; flex-direction: column; gap: 12px; }
    .donations-attention-item { border: 1px solid #E4E8EC; background: white; border-radius: 14px; padding: 15px 18px; }
    .donations-attention-item-danger { border-color: #F5B5A5; background: #FEF8F6; }
    .donations-attention-item-head { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 5px; gap: 8px; }
    .donations-attention-item-title { font-weight: 800; font-size: 14px; }
    .donations-attention-item-detail { font-size: 12.5px; color: #5A6870; line-height: 1.55; margin-bottom: 11px; }
    .donations-attention-item-actions { display: flex; gap: 8px; }
    .donations-attention-cta {
      padding: 7px 15px; border: none; border-radius: 99px; background: var(--dot-action); color: white;
      font-size: 12px; font-weight: 800; cursor: pointer;
    }
    .donations-attention-cta-secondary {
      padding: 6px 14px; border: 1.5px solid #E4E8EC; border-radius: 99px; background: transparent; color: #5A6870;
      font-size: 12px; font-weight: 800; cursor: pointer;
    }

    .donations-quick-dialog {
      width: min(100%, 560px); background: white; border-radius: 20px; box-shadow: 0 24px 80px rgba(34,45,50,.25);
      padding: 28px 32px; box-sizing: border-box;
    }
    .donations-quick-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px; }
    .donations-quick-title { font-family: 'Quicksand', sans-serif; font-size: 20px; font-weight: 700; }
    .donations-quick-close { color: var(--dot-muted); background: transparent; cursor: pointer; font-size: 16px; }
    .donations-quick-subtitle { font-size: 12.5px; color: var(--dot-muted); margin-bottom: 18px; }
    .donations-gift-fields { min-width: 0; border: 0; padding: 0; margin: 0; }
    .donations-quick-note { margin-bottom: 10px; }
    .donations-quick-fields { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 14px; }
    .donations-quick-field-label { font-size: 12px; font-weight: 800; margin-bottom: 5px; }
    .donations-quick-giver-search { position: relative; }
    .donations-quick-giver-input, .donations-quick-amount-input {
      width: 100%; box-sizing: border-box; border: 2px solid #F26223; border-radius: 12px; padding: 11px 14px;
      font-size: 14px; font-weight: 800; outline: none;
    }
    .donations-quick-amount-input { font-family: 'IBM Plex Mono', monospace; font-size: 15px; }
    .donations-quick-giver-results {
      position: absolute; z-index: 5; top: calc(100% + 4px); left: 0; right: 0; max-height: 220px; overflow: auto;
      border: 1px solid #E4E8EC; border-radius: 12px; background: white; box-shadow: 0 12px 28px rgba(34,45,50,.14);
    }
    .donations-quick-giver-result {
      display: flex; align-items: center; gap: 9px; width: 100%; padding: 9px 12px; border: none;
      background: transparent; text-align: left; cursor: pointer; font-size: 13px;
    }
    .donations-quick-giver-result:hover { background: #FDE5DA; }
    .donations-quick-selected-giver {
      display: flex; align-items: center; gap: 9px; border: 2px solid #F26223; border-radius: 12px; padding: 11px 14px;
      font-size: 14px; font-weight: 800;
    }
    .donations-quick-defaults {
      background: #F7F8FA; border: 1px solid #E4E8EC; border-radius: 14px; padding: 14px 16px; margin-bottom: 18px;
    }
    .donations-quick-defaults-label {
      font-family: 'IBM Plex Mono', monospace; font-size: 9.5px; color: #5B4AA8; letter-spacing: 1px; margin-bottom: 9px;
    }
    .donations-quick-chip-row { display: flex; flex-wrap: wrap; gap: 7px; }
    .donations-quick-chip {
      background: white; border: 1px solid #E4E8EC; font-size: 11.5px; font-weight: 800; padding: 5px 12px;
      border-radius: 99px; cursor: pointer;
    }
    .donations-quick-note { font-size: 11.5px; color: #5A6870; margin-top: 10px; }
    .donations-quick-more { margin-bottom: 16px; display: grid; gap: 10px; }
    .donations-quick-more-toggle {
      border: none; background: transparent; color: #5A6870; font-size: 12.5px; font-weight: 800; cursor: pointer;
      padding: 4px 0; margin-bottom: 10px;
    }
    .donations-quick-actions { display: flex; gap: 10px; }
    .donations-quick-actions > * { flex: 1; }
    .donations-quick-actions .donations-quick-save { flex: 2; }

    .donations-yearend-dialog {
      width: min(100%, 560px); background: #222D32; color: white; border-radius: 20px;
      box-shadow: 0 24px 80px rgba(34,45,50,.25); padding: 28px 32px; box-sizing: border-box;
    }
    .donations-yearend-head { display: flex; align-items: center; gap: 12px; margin-bottom: 14px; }
    .donations-yearend-icon {
      width: 44px; height: 44px; border-radius: 12px; background: #F26223; display: flex; align-items: center;
      justify-content: center; font-size: 20px; flex: 0 0 auto;
    }
    .donations-yearend-title { font-family: 'Quicksand', sans-serif; font-size: 19px; font-weight: 700; }
    .donations-yearend-subtitle { font-size: 12px; color: #8FA0AA; }
    .donations-yearend-stats { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 8px; margin-bottom: 16px; }
    .donations-yearend-stat { background: rgba(255,255,255,.07); border-radius: 11px; padding: 11px 13px; }
    .donations-yearend-stat-label { font-family: 'IBM Plex Mono', monospace; font-size: 9px; color: #8FA0AA; }
    .donations-yearend-stat-value { font-family: 'Quicksand', sans-serif; font-size: 18px; font-weight: 700; }
    .donations-yearend-checklist { display: flex; flex-direction: column; gap: 8px; margin-bottom: 18px; font-size: 13px; color: #C9D3D9; }
    .donations-yearend-actions { display: flex; gap: 10px; }
    .donations-yearend-actions > * { flex: 1; }
    .donations-yearend-close { background: transparent; border: none; color: #8FA0AA; cursor: pointer; font-size: 16px; float: right; }
    .donations-yearend-preview {
      margin-top: 14px; padding: 12px 14px; border-radius: 12px; background: rgba(255,255,255,.07); font-size: 12.5px;
    }

    @media (max-width: 760px) {
      .donations-ledger-head { display: none; }
      .donations-row { grid-template-columns: 1fr auto; row-gap: 4px; }
      .donations-topbar-actions { width: 100%; margin-left: 0; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }
      .donations-topbar-actions > * { width: 100%; min-height: 42px; padding: 8px; border-radius: 12px; font-size: 12px; }
      .donations-search { width: 100%; }
      .donations-month-total { width: 100%; margin-left: 0; }
      .donations-row { grid-template-areas: "giver amount" "target date" "source qbo"; gap: 8px; }
      .donations-row-giver { grid-area: giver; }
      .donations-row-target { grid-area: target; font-size: 11.5px; }
      .donations-row-date { grid-area: date; font-size: 11px; text-align: right; }
      .donations-row-source { grid-area: source; }
      .donations-row-qbo { grid-area: qbo; justify-self: end; }
      .donations-row-amount { grid-area: amount; }
      .donations-quick-dialog, .donations-yearend-dialog { padding: 22px 18px; }
      .donations-row-giver > div:last-child { min-width: 0; }
      .donations-gift-fields { min-width: 0; border: 0; padding: 0; margin: 0; }
    .donations-quick-note { margin-bottom: 10px; }
    .donations-quick-fields { grid-template-columns: 1fr; }
      .donations-yearend-stats { grid-template-columns: 1fr; }
    }
""".trimIndent()

val DonationsStyles = FC<Props> {
    style { +donationsStyles }
}
